import React, { useState } from "react";
import {
  Button,
  Container,
  TextField,
  Typography,
  Grid,
  Divider,
  IconButton,
  NativeSelect,
  FormControl,
  InputLabel,
} from "@mui/material";

import { Box } from "@mui/system";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const DesignerToolSideBar = () => {
  const [formValues, setFormValues] = useState({
    name: {
      value: "",
      error: false,
      errorMessage: "You must enter a name",
    },
    description: {
      value: "",
      error: false,
      errorMessage: "You must enter description",
    },
  });

  const [alignment, setAlignment] = React.useState("properties");
  const [Value, setValue] = React.useState("");

  const handleTabChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setAlignment(newAlignment);
  };

  const handleSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setValue(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;

      if (currentValue === "") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
      }
    }

    setFormValues(newFormValues);
  };

  return (
    <Container>
      <Box fullWidth md={4} sx={{ flexGrow: 1, margin: 1, px: 4 }}>
        <ToggleButtonGroup
          color="primary"
          value={alignment}
          exclusive
          onChange={handleTabChange}
          aria-label="Properties Tab"
        >
          <ToggleButton size="large" value="properties">
            PROPERTIES
          </ToggleButton>
          <ToggleButton size="large" value="layers">
            LAYERS
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Container
        type="form"
        noValidate
        onSubmit={handleSubmit}
        justifyContent="center"
        display="flex"
        sx={{
          padding: 2,
          backgroundColor: "lightgrey",
        }}
      >
        <Typography variant="body2">
          <InputLabel id="service-area-label">Select Unit:</InputLabel>
        </Typography>

        <NativeSelect
          fullWidth
          id="service-area-select"
          value={Value}
          onChange={handleSelectChange}
          sx={{
            margin: 2,
          }}
        >
          <option value={""}></option>
          <option value={"splice"}>Splice Case</option>
          <option value={"cable"}>Cable</option>
        </NativeSelect>

        <Typography variant="body2">
          <InputLabel id="service-area-label">ID:</InputLabel>
        </Typography>
        <TextField
          placeholder="Describe Service Area details"
          name="description"
          variant="outlined"
          fullWidth
          required
          value={21}
          disabled
          onChange={handleChange}
          error={formValues.description.error}
          helperText={
            formValues.description.error && formValues.description.errorMessage
          }
          sx={{
            padding: 2,
          }}
        />
        <Typography variant="body2">
          <InputLabel id="service-area-label">Unit Type:</InputLabel>
        </Typography>
        <TextField
          placeholder="Describe Service Area details"
          name="description"
          variant="outlined"
          fullWidth
          required
          value={"Splice Case"}
          onChange={handleChange}
          error={formValues.description.error}
          helperText={
            formValues.description.error && formValues.description.errorMessage
          }
          sx={{
            padding: 2,
          }}
        />
        <Typography variant="body2">
          <InputLabel id="service-area-label">Association Status:</InputLabel>
        </Typography>
        <TextField
          placeholder="Describe Service Area details"
          name="description"
          variant="outlined"
          fullWidth
          required
          value={"None"}
          onChange={handleChange}
          error={formValues.description.error}
          helperText={
            formValues.description.error && formValues.description.errorMessage
          }
          sx={{
            padding: 2,
          }}
        />
        <Typography variant="body2">
          <InputLabel id="service-area-label">Route:</InputLabel>
        </Typography>
        <TextField
          placeholder="Describe Service Area details"
          name="description"
          variant="outlined"
          fullWidth
          required
          value={"Null"}
          onChange={handleChange}
          error={formValues.description.error}
          helperText={
            formValues.description.error && formValues.description.errorMessage
          }
          sx={{
            padding: 2,
          }}
        />
        <Typography variant="body2">
          <InputLabel id="service-area-label">Minimum Measure:</InputLabel>
        </Typography>
        <TextField
          placeholder="Describe Service Area details"
          name="description"
          variant="outlined"
          fullWidth
          required
          value={"10m"}
          onChange={handleChange}
          error={formValues.description.error}
          helperText={
            formValues.description.error && formValues.description.errorMessage
          }
          sx={{
            padding: 2,
          }}
        />
      </Container>
    </Container>
  );
};

export default DesignerToolSideBar;
